<template>
  <div class="bulma admin">
    <navbar></navbar>

    <section class="main-content columns is-fullheight">

      <sidebar></sidebar>

      <div class="container column is-9">
        <div v-if="$route.path === '/admin'">
          <home></home>
        </div>
        <router-view :key="$route.path"/>
      </div>
    </section>
  </div>
</template>

<script>
import Navbar from '@/admin/components/layout/Navbar'
import Sidebar from '@/admin/components/layout/Sidebar'
import Home from '@/admin/components/layout/Home'
import firebase from 'firebase'

export default {
  name: 'admin',
  components: {
    'navbar': Navbar,
    'sidebar': Sidebar,
    'home': Home
  },
  // prevent unauthenticated users from accessing the admin area
  // and direct them to the login page
  beforeRouteEnter (to, from, next) {
    // get the current logged in user
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // continue to /admin
        next()
      } else {
        // redirect to /login
        next('/login')
      }
    })
  }
}

</script>

<style lang="sass">
@import '../styles/index'
</style>



// WEBPACK FOOTER //
// src/admin/pages/Admin.vue